import Next from '../http/Next';

export const i18nNext = new Next('/i18n/{language}', 'I18N');
export const SET_LANGUAGE = 'SET_LANGUAGE';
